import { Box, Popover } from '@mui/material';
import { useState } from 'react';

export interface CategoryItemProps {
  no: number
  title: string
  description: string
  order: string
  handleEdit?: () => void
  handleDelete?: () => void
}

const CategoryItem = (props: CategoryItemProps) => {
  const {
    no, title, description, order, handleEdit, handleDelete,
  } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const onEdit = () => {
    setAnchorEl(null);
    handleEdit();
  };

  const onDelete = () => {
    setAnchorEl(null);
    handleDelete();
  };

  return (
<tr>
        <td className="text-center">{no}</td>
        <td>{title}</td>
        <td>{description}</td>
        <td className="table-action text-center">
            <div className="btn-group btn-group-sm">
                <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={handleClick}>
                    操作
                </button>

                <Popover
                  id={order}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                    <Box sx={{
                      paddingTop: '0.6rem',
                      paddingBottom: '0.6rem',
                    }}
                    >
                        <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#itemeditModal" onClick={onEdit}>
                            <i className="fa-solid fa-pen-to-square fa-fw" />
                            {' '}
                            編集
                        </a>
                        <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#itemdeleteModal" onClick={onDelete}>
                            <i className="fa-solid fa-trash fa-fw" />
                            {' '}
                            削除
                        </a>
                    </Box>
                </Popover>
            </div>
        </td>
</tr>
  );
};

export default CategoryItem;
